import * as React from 'react';

export default function useStyleSheet(css: string, id: string) {
  React.useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById(id)) return;

    const el = document.createElement('style');
    el.id = id;
    el.textContent = css;
    document.head.appendChild(el);
  }, [css, id]);
}
